import request from '@/utils/request'
import type { LoginRequest, LoginResponse } from '@/types/user'

export const login = (data: LoginRequest): Promise<LoginResponse> => {
  return request.post('/auth/login', data)
}

export const logout = (): Promise<void> => {
  return request.post('/auth/logout')
}

export const getCurrentUser = (): Promise<any> => {
  return request.get('/auth/currentUser')
} 